import React, { useState } from "react";
import { HStack, IconButton, Tooltip, useColorMode } from "@chakra-ui/react";
import {
  Flame,
  CheckCircle,
  ArrowLeft,
  BarChart2,
  CheckCircleIcon,
  AlertTriangle,
} from "lucide-react"; // Updated icons for better representation

interface IconComponentProps {
  onBurnoutClick: () => void;
  onChartClick: () => void;
  onCheckoutClick: () => void;
  onDashBoardClick: () => void;
}

const IconComponent: React.FC<IconComponentProps> = ({
  onBurnoutClick,
  onChartClick,
  onCheckoutClick,
  onDashBoardClick,
}) => {
  // State to track the active icon
  const [activeIcon, setActiveIcon] = useState<string>("dashboard");
  const { colorMode } = useColorMode();
  const isDark = colorMode === "dark";

  const handleBurnoutClick = () => {
    setActiveIcon("burnout");
    onBurnoutClick();
  };

  const handleChartClick = () => {
    setActiveIcon("chart");
    onChartClick();
  };

  const handleCheckoutClick = () => {
    setActiveIcon("checkout");
    onCheckoutClick();
  };

  const handleDashBoardClick = () => {
    setActiveIcon("dashboard");
    onDashBoardClick();
  };

  return (
    <HStack spacing={4}>
      {/* <Tooltip label="View Task Chart">
        <IconButton
          icon={<BarChart2 size={18} />}
          aria-label="Task Chart"
          variant="ghost"
          onClick={handleChartClick}
          borderRadius="50%"
          backgroundColor={activeIcon === "chart" ? "purple.300" : "gray.100"}
          _hover={{ backgroundColor: "purple.100" }}
          _active={{ backgroundColor: "purple.200" }}
        />
      </Tooltip> */}

      <Tooltip label="Overall Dashboard">
        <IconButton
          icon={<AlertTriangle size={18} strokeWidth={2} />}
          aria-label="Overall Dashboard"
          onClick={() => {
            setActiveIcon("dashboard");
            onDashBoardClick();
          }}
          borderRadius="50%"
          backgroundColor={isDark ? "black" : "#FFF7E6"}
          borderColor="#B59143"
          borderWidth="1px"
          color="#B59143"
          _hover={{ 
            backgroundColor: isDark ? "black" : "#FFF7E6", 
            borderColor: "#FFD700", 
            color: "#FFD700" 
          }}
          _active={{ 
            backgroundColor: isDark ? "black" : "#FFF7E6", 
            borderColor: "#B59143", 
            color: "#B59143" 
          }}
        />
      </Tooltip>
      <Tooltip label="Check-Out Stress Level">
        <IconButton
          icon={<CheckCircleIcon size={18} />}
          aria-label="Check-Out Stress Level"
          onClick={handleCheckoutClick}
          borderRadius="50%"
          backgroundColor={isDark ? "black" : "#FFF7E6"}
          borderColor="#B59143"
          borderWidth="1px"
          color="#B59143"
          _hover={{ 
            backgroundColor: isDark ? "black" : "#FFF7E6", 
            borderColor: "#FFD700", 
            color: "#FFD700" 
          }}
          _active={{ 
            backgroundColor: isDark ? "black" : "#FFF7E6", 
            borderColor: "#B59143", 
            color: "#B59143" 
          }}
        />
      </Tooltip>

      {/* <Tooltip label="View Burnout Level">
        <IconButton
          icon={<Flame size={18} />}
          aria-label="Burnout Level"
          variant="ghost"
          onClick={handleBurnoutClick}
          borderRadius="50%"
          backgroundColor={activeIcon === "burnout" ? "purple.300" : "gray.100"}
          _hover={{ backgroundColor: "purple.100" }}
          _active={{ backgroundColor: "purple.200" }}
        />
      </Tooltip> */}
    </HStack>
  );
};

export default IconComponent;
